import { createAction } from 'redux-actions';

import * as actionTypes from '../actionTypes/role';

export const doReadRoleList = createAction(actionTypes.ROLE_LIST_READ_REQUESTED);
export const doReadRoleListSuccess = createAction(actionTypes.ROLE_LIST_READ_SUCCEEDED);
export const doReadRoleListFailure = createAction(actionTypes.ROLE_LIST_READ_FAILED);
export const doRoleListReset = createAction(actionTypes.ROLE_LIST_RESET);
